import Contracts from '../../../services/contracts'
import TransferCreditValue from './transfer-credit-value.vue'
import Sales from '../../../services/sales'
import Param from '../../../services/param'
import Auth from '../../../services/auth'
import {
  centss
} from '../../../filters/number'
import Account from '../../../services/account'

export default {
  data() {
    return {
      searchCpf: undefined,
      searchContract: undefined,
      status: '',
      userReceive: undefined,
      messageError: undefined,
      taxIdNumber: undefined,
      step: 1,
      transfValue: undefined,
      loading: undefined,
      contract: undefined,
      contractIdCred: undefined,
      fee: undefined,
      feeValue: undefined,
      total: undefined,
      password: undefined,
      taxIdSender: undefined
    }
  },
  computed: {
    formattedValue() {
      return centss(this.transfValue);
    },
    formattedFeeValue() {
      return centss(this.feeValue);
    },
    formattedTotal() {
      return centss(this.total);
    },
    checkValue() {
      return !this.transfValue || this.transfValue === 0;
    },
    contratoOrigem() {
      return this.$route.params.contractId;
    }
  },
  methods: {
    nextStep() {
      switch (this.step) {
        case 1:
          if (!this.userReceive) {
            this.messageError = 'Informe o CPF';
            this.status = 'ERROR';
            return;
          }
          this.step += 1;
          break;
        case 2:
          if (!this.transfValue || this.transfValue <= 0) {
            this.messageError = 'Informe o valor a ser creditado';
            this.status = 'ERROR';
            return;
          }
          this.step += 1;
          break;
        default:
          this.step += 1;
      }
    },

    calculate() {
      this.fee = 2;
      this.feeValue = this.transfValue * (this.fee / 100);
      this.total = this.transfValue + this.feeValue;
    },


    filter() {
      let vm = this;
      this.status = 'EMPTY';
      this.transfValue = 0;

      if(this.searchContract == this.$route.params.contractId) {
        this.status = 'ERROR';
        this.messageError = 'O contrato do favorecido não pode ser o mesmo do transferente.';
        return;
      }

      this.$validator.validateAll().then(r => {

        this.loading = Account.getContractByTaxPayerIdSite(this.searchCpf.replace(/[^0-9]/g, ""), this.searchContract.replace(/[^0-9]/g, "")).then((response) => {
          this.taxIdNumber = this.searchCpf.replace(/[^0-9]/g, "");
          this.contractIdCred = this.searchContract.replace(/[^0-9]/g, "");
          this.userReceive = response;
          this.status = 'FOUND';
        }).catch(error => {
          this.messageError = error.data.status.message;
          this.status = 'ERROR';
        });
      }).catch(err => {
        this.status = 'ERROR';
        this.messageError = 'Dados inválidos';
      });
    },
    transfer() {
      this.status = 'FOUND';
      if(!this.password) {
        this.messageError = "Informe sua senha para realizar a transferência!";
        this.status = 'ERROR';
        return ;
      }

      //Autentica o usuário com o taxId e a senha novamente
      let prom = Auth.checkUserPasswordTransfer(this.taxIdSender, this.password).then(auth => {
        if (auth.authorized) {
          let transfRequest = {
            contractIdDeb: this.contratoOrigem,
            contractIdCred: this.userReceive.contratos[0].value,
            transferValue: this.transfValue
          };

          return Sales.transferCredit(transfRequest).then(res => {

            if(res.response.statusProcess) {
              this.$router.push({
                name: 'transfer-credit-receipt',
                params: {
                  orderId: res.response.orderId
                }
              });
            } else {
              this.messageError = res.response.status;
              this.status = 'ERROR';
            }

          }).catch(error => {

            this.messageError = error.data.status.message;
            this.status = 'ERROR';
          });
        } else {
          this.messageError = "Senha inválida!";
          this.status = 'ERROR';
        }
      }).catch(error => {

        this.messageError = error.data.status.message;
        this.status = 'ERROR';
      });

      this.$store.dispatch('loading', prom);

    },
  },
  watch: {
    transfValue(newValue) {
      this.transfValue = newValue;
      this.feeValue = this.transfValue * (this.fee / 100);
      this.total = this.transfValue + this.feeValue;
    }
  },
  mounted() {
    this.loading = Contracts.getContractByContractId(this.$route.params.contractId).then((response) => {
      this.contract = response;
    });
    //recupera o valor base da taxa de transferência
    Param.getGeneralParameter({
      key: "TAXA_TRANSFERENCIA"
    }).then((res) => {
      this.fee = parseInt(res.value)
    });

    //recupera o taxId do transferente para realizar a autenticação no último passo do processo]
    this.taxIdSender = Auth.getTaxId();
    this.taxIdSender = this.taxIdSender ? this.taxIdSender.replace(/[.\-\/]/g, "").toUpperCase() : Auth.currentUser.taxIdNumber;
  },
  components: {
    TransferCreditValue
  }

}



// WEBPACK FOOTER //
// ./src/pages/account/credit/transfer-credit.js